import {CardHeader, CardHeaderProps, Tooltip, Typography} from "@mui/material"
import MessageReference from "./MessageReference"
import {CountryAvatar} from "../../../../components/icons/CountryAvatar";

type MessageHeaderProps =
  Omit<CardHeaderProps, 'avatar' | 'title' | 'subheader' | 'sx'> & {
  idSistemaPrincipal: number
  nombreSistemaPrincipal: string
  nombreSistema: string
  referencia: string
  messageId: number
}

const MessageHeader = (props: MessageHeaderProps) => {
  const {idSistemaPrincipal, nombreSistema, nombreSistemaPrincipal, referencia, messageId, ...cardProps} = props

  return (
    <CardHeader
      avatar={<CountryAvatar
        countryCode={idSistemaPrincipal}
        sx={{height: '40px', width: '40px', mt: 0.5}}
      />}
      title={
        <Tooltip title={nombreSistema}>
          <Typography noWrap variant='h6'>{nombreSistema}</Typography>
        </Tooltip>
      }
      subheader={
        <MessageReference referencia={referencia} id={messageId}/>
      }
      sx={{
        pb: 1,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        '& .MuiCardHeader-avatar': {mr: 2},
        '& .MuiCardHeader-content': {overflow: 'hidden'},
        width: '100%'
      }}
      {...cardProps}
    />
  )
}

export default MessageHeader
